import classNames from "classnames";
import { Typography } from "PFComponents/typography";
import React from "react";

import css from "./panel.module.scss";

type PanelProps = {
  title: string;
  actionsChildren?: JSX.Element;
  classes?: {
    container: string;
    header: string;
  };
};

export const Panel = ({
  classes,
  title,
  children,
  actionsChildren
}: React.PropsWithChildren<PanelProps>): JSX.Element => (
  <div className={classNames(css.container, classes?.container)}>
    <div className={classNames(css.header, classes?.header)}>
      <Typography variant="h4">{title}</Typography>
      {actionsChildren && <span>{actionsChildren}</span>}
    </div>
    {children}
  </div>
);
